module.exports = __webpack_public_path__ + "static/media/github-icon.e0edbb12.svg";